"use client";

import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import {
  Play,
  X,
  Flame,
  Star,
  Sparkles,
  Video,
  ChevronRight,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useLanguage } from "@/app/context/LanguageContext";

const VIDEOS = [
  {
    id: "1",
    youtubeId: "j4TCgkq3g-A",
    titleEn: "Auspicious Pournami Oracle - Divine Revelations",
    descriptionEn:
      "Experience the sacred spiritual guidance and divine messages shared during the monthly Full Moon gathering.",
    titleTa: "மங்களகரமான பௌர்ணமி அருள்வாக்கு - தெய்வீக வெளிப்பாடுகள்",
    descriptionTa:
      "மாதாந்திர பௌர்ணமி ஆன்மீகக் கூட்டத்தின் போது பக்தர்களுக்காக பகிரப்பட்ட புனித ஆன்மீக செய்திகள்.",
    tag: "Pournami",
  },
  {
    id: "2",
    youtubeId: "xVmjrAybQkA",
    titleEn: "Monthly Spiritual Guidance & Rituals",
    descriptionEn:
      "Step into the serenity of Lord Karuppanasamy's monthly spiritual sessions, where tradition meets divine wisdom.",
    titleTa: "மாதாந்திர ஆன்மீக வழிகாட்டுதல் மற்றும் சடங்குகள்",
    descriptionTa:
      "கருப்பண்ணசாமி ஆலயத்தின் மாதாந்திர ஆன்மீக அமர்வுகளின் வழியாக வெளிப்படும் தெய்வீக ஞானம்.",
    tag: "Monthly",
  },
  {
    id: "3",
    youtubeId: "GaJ59ypu3lM",
    titleEn: "Sacred Legends - The Bestowing of Divine Boons",
    descriptionEn:
      "Exploring the powerful spiritual narrative of Lord Karuppanasamy granting protection and sacred boons.",
    titleTa: "புனித இதிகாசம் - தெய்வீக வரங்கள் அருளுதல்",
    descriptionTa:
      "கருப்பண்ணசாமி தனது பக்தர்களுக்கு வாரி வழங்கும் பாதுகாப்பு மற்றும் தெய்வீக வரங்களின் ஆன்மீகத் தொகுப்பு.",
    tag: "Legends",
  },
  {
    id: "4",
    youtubeId: "4Nh1mwsv3a8",
    titleEn: "Intense Arulvaku Ritual - Sacred Devotion",
    descriptionEn:
      "A deep immersion into the traditional Arulvaku practices, showcasing raw spiritual energy and sacred devotion.",
    titleTa: "உக்கிர அருள்வாக்குச் சடங்கு - புனித பக்தி",
    descriptionTa:
      "பாரம்பரிய அருள்வாக்குச் சடங்குகளின் உன்னதமான ஆன்மீக சக்தி மற்றும் பக்தியை வெளிப்படுத்தும் காட்சி.",
    tag: "Arulvaku",
  },
  {
    id: "5",
    youtubeId: "8uEsdSWWDKE",
    titleEn: "Divine Intervention & Spiritual Purification",
    descriptionEn:
      "Observing the profound rituals of spiritual clearance rooted in ancient Tamil spiritual traditions.",
    titleTa: "தெய்வீக தலையீடு மற்றும் ஆன்மீகத் தூய்மை",
    descriptionTa:
      "பண்டைய தமிழ் ஆன்மீக மரபுகளைப் பின்பற்றி செய்யப்படும் ஆன்மீகத் தூய்மைப்படுத்தல் சடங்குகள்.",
    tag: "Ritual",
  },
  {
    id: "6",
    youtubeId: "iX7pm-gOaB4",
    titleEn: "Sacred Arulvaku - Auspicious Full Moon Oracle",
    descriptionEn:
      "Divine highlights from the powerful oracle session during the grand 2023 Full Moon celebrations.",
    titleTa: "புனித அருள்வாக்கு - பௌர்ணமி ஆசி",
    descriptionTa:
      "2023-ம் ஆண்டு பிரத்யேக பௌர்ணமி விழாவின் போது வழங்கப்பட்ட சக்திவாய்ந்த அருள்வாக்கு சிறப்பம்சங்கள்.",
    tag: "2023",
  },
  {
    id: "7",
    youtubeId: "ZT0uUwFJuIc",
    titleEn: "Authentic Darshan - A Journey of Faith",
    descriptionEn:
      "An intimate look into the divine bond between the guardian deity and devotees during sacred rituals.",
    titleTa: "உண்மையான தரிசனம் - ஒரு பக்திப் பயணம்",
    descriptionTa:
      "காவல் தெய்வமான கருப்பண்ணசாமியுடன் பக்தர்கள் புனித சடங்குகள் மூலம் ஏற்படுத்திக்கொள்ளும் தெய்வீகத் தொடர்பு.",
    tag: "Darshan",
  },
  {
    id: "8",
    youtubeId: "7ENKvkcV_Zw",
    titleEn: "Traditional Healing & Divine Protection",
    descriptionEn:
      "Discover the temple's ancestral practices for spiritual healing and seeking divine protection.",
    titleTa: "பாரம்பரிய ஆன்மீக சிகிச்சை மற்றும் பாதுகாப்பு",
    descriptionTa:
      "எதிர்மறைகளை நீக்கி ஆன்மீக நலம் மற்றும் தெய்வீகப் பாதுகாப்பைப் பெறுவதற்கான பாரம்பரிய வழிமுறைகள்.",
    tag: "Healing",
  },
  {
    id: "9",
    youtubeId: "XJI6vPdNTPw",
    titleEn: "Divine Solutions for Life's Obstacles",
    descriptionEn:
      "Seek divine clarity and spiritual remedies through Karuppanasamy Arulvaku to overcome challenges.",
    titleTa: "வாழ்வியல் தடைகளுக்கான தெய்வீகத் தீர்வுகள்",
    descriptionTa:
      "வாழ்வின் சவால்களை முறியடிக்க கருப்பண்ணசாமியின் புனித அருள்வாக்கு மூலம் தெய்வீகத் தெளிவு பெறுதல்.",
    tag: "Guidance",
  },
];

export default function VideoGalleryPage() {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [hoveredId, setHoveredId] = useState<string | null>(null);
  const { language } = useLanguage();

  const selectedMeta = VIDEOS.find((v) => v.youtubeId === selectedVideo);

  return (
    <div className="space-y-16 font-serif">
      {/* ── Section header ─────────────────────────────────────── */}
      <div className="text-center space-y-4">
        <p className="font-sans text-[10px] tracking-[0.4em] uppercase text-amber-500/70">
          ✦ {language === "ta" ? "புனித காணொளிகள்" : "Sacred Videos"} ✦
        </p>
        <h2 className="text-4xl sm:text-5xl font-bold bg-gradient-to-br from-amber-100 via-yellow-400 to-orange-500 bg-clip-text text-transparent">
          {language === "ta"
            ? "தெய்வீக காணொளி தொகுப்பு"
            : "Divine Video Gallery"}
        </h2>
        <div className="flex items-center justify-center gap-3">
          <div className="h-px w-16 bg-gradient-to-r from-transparent to-amber-600" />
          <Flame className="h-4 w-4 text-amber-500" />
          <Star className="h-3 w-3 text-amber-400 fill-amber-400" />
          <Flame className="h-4 w-4 text-amber-500" />
          <div className="h-px w-16 bg-gradient-to-l from-transparent to-amber-600" />
        </div>
        <div className="flex justify-center">
          <Badge
            variant="outline"
            className="border-amber-700/50 bg-amber-950/40 text-amber-400 font-sans text-xs px-4 py-1.5 tracking-widest"
          >
            <Video className="h-3.5 w-3.5 mr-2" />
            {VIDEOS.length} {language === "ta" ? "காணொளிகள்" : "Videos"}
          </Badge>
        </div>
      </div>

      {/* ── Featured first video (hero card) ──────────────────── */}
      {(() => {
        const hero = VIDEOS[0];
        const heroTitle = language === "ta" ? hero.titleTa : hero.titleEn;
        const heroDesc =
          language === "ta" ? hero.descriptionTa : hero.descriptionEn;
        return (
          <div
            onClick={() => setSelectedVideo(hero.youtubeId)}
            className="group relative cursor-pointer overflow-hidden rounded-3xl border border-stone-800 hover:border-amber-700/60 bg-stone-900 shadow-2xl shadow-stone-950/60 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_60px_rgba(180,83,9,0.30)]"
          >
            {/* thumbnail */}
            <div className="relative aspect-[21/9] w-full overflow-hidden">
              <img
                src={`https://img.youtube.com/vi/${hero.youtubeId}/maxresdefault.jpg`}
                alt={heroTitle}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                onError={(e) => {
                  e.currentTarget.src = `https://img.youtube.com/vi/${hero.youtubeId}/hqdefault.jpg`;
                }}
              />
              {/* gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-stone-950 via-stone-950/40 to-transparent" />
              <div className="absolute inset-0 bg-gradient-to-r from-stone-950/70 via-transparent to-transparent" />

              {/* top accent */}
              <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-amber-600/60 to-transparent" />

              {/* play button centre */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative">
                  <div className="absolute inset-0 rounded-full bg-amber-500/20 scale-150 group-hover:scale-[2] transition-transform duration-500" />
                  <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-amber-500 flex items-center justify-center shadow-2xl shadow-amber-900/60 group-hover:scale-110 transition-transform duration-300">
                    <Play className="h-7 w-7 sm:h-9 sm:w-9 fill-stone-950 text-stone-950 translate-x-0.5" />
                  </div>
                </div>
              </div>

              {/* Featured badge */}
              <div className="absolute top-4 left-4">
                <span className="font-sans text-[10px] font-bold tracking-[0.2em] uppercase px-3 py-1.5 rounded-full border border-amber-600/60 bg-amber-950/70 text-amber-300 backdrop-blur-sm">
                  ✦ {language === "ta" ? "சிறப்புக் காணொளி" : "Featured"}
                </span>
              </div>

              {/* tag badge */}
              <div className="absolute top-4 right-4">
                <span className="font-sans text-[10px] font-semibold tracking-widest uppercase px-3 py-1.5 rounded-full border border-stone-600/60 bg-stone-950/70 text-stone-300 backdrop-blur-sm">
                  {hero.tag}
                </span>
              </div>
            </div>

            {/* text below */}
            <div className="px-6 sm:px-8 py-6 sm:py-7 space-y-2">
              <h3 className="text-xl sm:text-2xl font-bold text-amber-200 group-hover:text-amber-300 transition-colors line-clamp-2 leading-snug">
                {heroTitle}
              </h3>
              <p className="font-sans text-sm text-stone-400 leading-relaxed line-clamp-2">
                {heroDesc}
              </p>
              <div className="pt-2 flex items-center gap-2 font-sans text-xs text-amber-500 font-semibold tracking-wide">
                <Play className="h-3.5 w-3.5 fill-amber-500" />
                {language === "ta" ? "காண்க" : "Watch Now"}
                <ChevronRight className="h-3.5 w-3.5" />
              </div>
            </div>
          </div>
        );
      })()}

      {/* ── Grid -  remaining videos ────────────────────────────── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {VIDEOS.slice(1).map((video, index) => {
          const title = language === "ta" ? video.titleTa : video.titleEn;
          const description =
            language === "ta" ? video.descriptionTa : video.descriptionEn;
          const isHovered = hoveredId === video.id;

          return (
            <div
              key={video.id}
              onClick={() => setSelectedVideo(video.youtubeId)}
              onMouseEnter={() => setHoveredId(video.id)}
              onMouseLeave={() => setHoveredId(null)}
              className="group relative cursor-pointer overflow-hidden rounded-2xl border border-stone-800 bg-stone-900 shadow-lg shadow-stone-950/50 transition-all duration-300 hover:-translate-y-1 hover:border-amber-700/50 hover:shadow-[0_12px_40px_rgba(180,83,9,0.25)] flex flex-col"
            >
              {/* thumbnail */}
              <div className="relative aspect-video w-full overflow-hidden shrink-0">
                <img
                  src={`https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`}
                  alt={title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.06]"
                />

                {/* overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-stone-950/10 to-transparent opacity-60 group-hover:opacity-90 transition-opacity duration-300" />

                {/* top line */}
                <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-amber-700/0 group-hover:via-amber-700/50 to-transparent transition-all duration-500" />

                {/* play button */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative">
                    <div className="absolute inset-0 rounded-full bg-amber-500/15 scale-0 group-hover:scale-[2.5] transition-transform duration-500" />
                    <div className="relative w-12 h-12 rounded-full bg-amber-500/90 group-hover:bg-amber-400 flex items-center justify-center shadow-xl shadow-amber-900/50 scale-90 group-hover:scale-100 transition-all duration-300">
                      <Play className="h-5 w-5 fill-stone-950 text-stone-950 translate-x-0.5" />
                    </div>
                  </div>
                </div>

                {/* number badge */}
                <div className="absolute top-2.5 left-2.5 w-7 h-7 rounded-full bg-stone-950/80 border border-stone-700/60 flex items-center justify-center backdrop-blur-sm">
                  <span className="font-sans text-[10px] font-bold text-stone-300">
                    {index + 2}
                  </span>
                </div>

                {/* tag badge */}
                <div className="absolute top-2.5 right-2.5 translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
                  <span className="font-sans text-[9px] font-bold tracking-[0.18em] uppercase px-2.5 py-1 rounded-full border border-amber-700/50 bg-amber-950/80 text-amber-400 backdrop-blur-sm">
                    {video.tag}
                  </span>
                </div>

                {/* duration-style bottom bar */}
                <div className="absolute bottom-2 right-2.5">
                  <span className="font-sans text-[10px] font-semibold px-2 py-0.5 rounded bg-stone-950/80 text-stone-300 border border-stone-700/40 backdrop-blur-sm">
                    YouTube
                  </span>
                </div>
              </div>

              {/* text area */}
              <div className="flex flex-col flex-1 p-4 sm:p-5 space-y-2">
                <h3 className="font-bold text-base text-amber-200 group-hover:text-amber-300 transition-colors line-clamp-2 leading-snug">
                  {title}
                </h3>
                <p className="font-sans text-xs text-stone-500 leading-relaxed line-clamp-2 flex-1">
                  {description}
                </p>
                <div className="pt-2 flex items-center justify-between">
                  <div className="flex items-center gap-1.5 font-sans text-[11px] text-amber-600 font-semibold tracking-wide">
                    <Play className="h-3 w-3 fill-amber-600" />
                    {language === "ta" ? "காண்க" : "Watch"}
                  </div>
                  <ChevronRight className="h-3.5 w-3.5 text-stone-600 group-hover:text-amber-600 group-hover:translate-x-0.5 transition-all duration-200" />
                </div>
              </div>

              {/* bottom accent line */}
              <div className="h-px bg-gradient-to-r from-transparent via-amber-800/0 group-hover:via-amber-700/40 to-transparent transition-all duration-500" />
            </div>
          );
        })}
      </div>

      {/* ── bottom ornament ────────────────────────────────────── */}
      <div className="flex items-center justify-center gap-4 pt-4">
        <div className="h-px w-20 bg-gradient-to-r from-transparent to-amber-800/40" />
        <Sparkles className="h-4 w-4 text-amber-700/60" />
        <Flame className="h-5 w-5 text-amber-500/80" />
        <Sparkles className="h-4 w-4 text-amber-700/60" />
        <div className="h-px w-20 bg-gradient-to-l from-transparent to-amber-800/40" />
      </div>

      {/* ── Video lightbox dialog ──────────────────────────────── */}
      <Dialog
        open={!!selectedVideo}
        onOpenChange={(open) => !open && setSelectedVideo(null)}
      >
        <DialogContent
          className="max-w-[96vw] xl:max-w-screen-xl border-stone-800 bg-stone-950/98 p-0 shadow-2xl backdrop-blur-2xl [&>button]:hidden outline-none rounded-2xl overflow-hidden"
          aria-describedby={undefined}
        >
          <DialogTitle className="sr-only">Video Player</DialogTitle>

          <div className="flex flex-col">
            {/* dialog header */}
            <div className="flex items-center justify-between border-b border-stone-800/80 px-5 py-3.5 bg-stone-900/60">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-amber-950/60 border border-amber-800/40 flex items-center justify-center">
                  <Video className="h-4 w-4 text-amber-500" />
                </div>
                {selectedMeta && (
                  <span className="font-serif font-semibold text-sm text-stone-200 line-clamp-1 max-w-[55vw]">
                    {language === "ta"
                      ? selectedMeta.titleTa
                      : selectedMeta.titleEn}
                  </span>
                )}
              </div>
              <Button
                size="icon"
                variant="ghost"
                onClick={() => setSelectedVideo(null)}
                className="h-9 w-9 rounded-xl text-stone-400 hover:text-stone-100 hover:bg-stone-800 shrink-0"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>

            {/* iframe */}
            <div className="relative w-full aspect-video bg-stone-900 group">
              {/* Floating cancel button */}
             <Button
  size="icon"
  variant="ghost"
  onClick={() => setSelectedVideo(null)}
  className="absolute top-3 right-3 sm:top-4 sm:right-4 z-50 h-10 w-10 rounded-full bg-stone-950/70 text-white hover:text-white hover:bg-stone-950/90 hover:scale-105 transition-all shadow-xl backdrop-blur-md border border-stone-800/80"
>
  <X className="h-5 w-5 text-white" />
</Button>
              {selectedVideo && (
                <iframe
                  src={`https://www.youtube.com/embed/${selectedVideo}?autoplay=1&modestbranding=1&rel=0`}
                  title="Video Player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                  className="absolute inset-0 w-full h-full border-0"
                />
              )}
            </div>

            {/* dialog footer */}
            {selectedMeta && (
              <div className="border-t border-stone-800/80 px-5 py-3.5 bg-stone-900/60 space-y-1">
                <p className="font-sans text-xs text-stone-400 leading-snug line-clamp-2">
                  {language === "ta"
                    ? selectedMeta.descriptionTa
                    : selectedMeta.descriptionEn}
                </p>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
